import { Component, Vue } from "vue-property-decorator";
import template from "./forgot-password.template.vue";
import { USERNAME_RULES } from "@/validators";

@Component({
  mixins: [template]
})
export default class ForgotPasswordComponent extends Vue {
  public user = "";
  public valid = false;
  public userNameRules = USERNAME_RULES;

  async validate() {
    if ((this.$refs.forgotPassForm as HTMLFormElement).validate()) {
      this.goToLogin();
    }
  }

  goToLogin() {
    this.$router.push("/login");
  }
}
